const generateQueryString = params => {
  if (params && typeof params === "object") {
    return Object.keys(params).reduce(function(query, key) {
      if (query.length > 0) query += "&";
      return query + key + "=" + encodeURIComponent(params[key]);
    }, "");
  }
  return "";
};

export const trackEvent = (eventType, params) => {
  const ANALYTICS_BASE_URL = "https://anduin.mdlinx.com/pixel";
  const imgUrl =
    ANALYTICS_BASE_URL +
    "?" +
    generateQueryString({
      ...params,
      event_type: eventType
    });

  if (imgUrl.length > 2083) {
    console.error(
      "Tracking pixel URL exceeds maximum allowable length in IE9",
      imgUrl
    );
  }

  const gif = document.createElement("img");
  gif.onload = () => {
    const parent = gif.parentElement;
    parent.removeChild(gif);
  };
  gif.src = imgUrl;
  gif.setAttribute(
    "style",
    "opacity: 0; position: fixed; top: 0; left: 0; height: 1px; width: 1px"
  );
  document.body.appendChild(gif);
};

export default trackEvent;
